import JSEncrypt from 'jsencrypt';
import {BASE_URL} from "@/utils/constants";
import axios from 'axios';

/**
 * 获取RSA公钥
 * @returns {Promise<string>} 公钥字符串
 */
export async function getPublicKey() {
  try {
    const response = await axios({
      url: BASE_URL + 'publicKey',
      method: 'get'
    });
    
    if (response.data.ok) {
      // 后端返回的是Base64编码的公钥，需要解码
      const base64PublicKey = response.data.msg;
      // 将Base64字符串解码为原始公钥字符串
      const publicKey = atob(base64PublicKey);
      return publicKey;
    } else {
      throw new Error('获取公钥失败: ' + response.data.msg);
    }
  } catch (error) {
    console.error('获取公钥失败:', error);
    throw error;
  }
}

/**
 * 使用RSA公钥加密密码
 * @param {string} password - 需要加密的密码
 * @param {string} publicKey - RSA公钥
 * @returns {string} 加密后的密码
 */
export function encryptPassword(password, publicKey) {
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(publicKey);
  const encrypted = encryptor.encrypt(password);
  
  if (!encrypted) {
    throw new Error('密码加密失败');
  }
  
  return encrypted;
}

/**
 * 获取公钥并加密密码
 * @param {string} password - 需要加密的密码
 * @returns {Promise<string>} 加密后的密码
 */
export async function getPublicKeyAndEncrypt(password) {
  try {
    // 1. 获取公钥
    const publicKey = await getPublicKey();
    
    // 2. 使用公钥加密密码
    const encryptedPassword = encryptPassword(password, publicKey);
    
    return encryptedPassword;
  } catch (error) {
    console.error('密码加密过程失败:', error);
    throw error;
  }
}
